<section class="main-slider">
  <div class="item" data-time="18000">
    <div class="slide-image" style="background-image: url('{{ banner && banner.image }}')">
      <div id="fpslides" class="caption">
        <div id="mmbanner">
          <div class="pattern">
            <div class="homebanner" id="bannerAlert">
              <div class="row" *ngIf="noteSections.length > 0">
                <div class="col-sm-12 bannerTopline">
                  <app-home-page-announcements-section [noteSections]="noteSections"></app-home-page-announcements-section>
                </div>
              </div>
            </div>
            <div class="container center-container">
              <div class="row">
                <div class="col-sm-12" id="myndc">
                  <div class="row mt-80 newDivs">
                    <div *ngFor="let userCard of userCards; let i = index">
                      <div class="panel panel-default center-text">
                        <div class="panel-body">
                          <div class="imgp">
                            <img src="{{ userCard.headIcon }}" [ngClass]="userCard.headIconClass" alt="" />
                          </div>
                          <h4 class="card-title card-block">{{ userCard.title }}</h4>
                          <p class="card-text">{{ userCard.body }}</p>
                          <a href="{{ userCard.url }}" class="btn btn-primary">{{ userCard.buttonText }}</a>
                        </div>
                      </div>
                    </div>
                    <div class="fptitle">
                      <app-banner [banner]="banner" [isHomePage]="true" [isDefaultPageBanner]="false"></app-banner>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="item" data-time="18000">
    <div class="slide-image" style="background-image: url('{{ banner && banner.additionalImage1 }}')">
      <div id="fpslides" class="caption">
        <div id="mmbanner">
          <div class="pattern">
            <div class="homebanner" id="bannerAlert">
              <div class="row">
                <div class="col-sm-12 bannerTopline"><app-home-page-announcements-section [noteSections]="noteSections"></app-home-page-announcements-section></div>
              </div>
            </div>
            <div class="container center-container">
              <div class="row">
                <div class="col-sm-12" id="myndc">
                  <div class="row mt-80">
                    <div *ngFor="let userCard of userCards; let i = index">
                      <div class="panel panel-default center-text">
                        <div class="panel-body">
                          <div class="imgp">
                            <img src="{{ userCard.headIcon }}" [ngClass]="userCard.headIconClass" alt="" />
                          </div>
                          <h4 class="card-title card-block">{{ userCard.title }}</h4>
                          <p class="card-text">{{ userCard.body }}</p>
                          <a href="{{ userCard.url }}" class="btn btn-primary">{{ userCard.buttonText }}</a>
                        </div>
                      </div>
                    </div>
                    <div class="fptitle">
                      <app-banner [banner]="banner" [isHomePage]="true" [isDefaultPageBanner]="false"></app-banner>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="item" data-time="18000">
    <div class="slide-image" style="background-image: url('{{ banner && banner.additionalImage2 }}')">
      <div id="fpslides" class="caption">
        <div id="mmbanner">
          <div class="pattern">
            <div class="homebanner" id="bannerAlert">
              <div class="row">
                <div class="col-sm-12 bannerTopline">
                  <app-home-page-announcements-section [noteSections]="noteSections"></app-home-page-announcements-section>
                </div>
              </div>
            </div>
            <div class="container center-container">
              <div class="row">
                <div class="col-sm-12" id="myndc">
                  <div class="row mt-80">
                    <div *ngFor="let userCard of userCards; let i = index">
                      <div class="panel panel-default center-text">
                        <div class="panel-body">
                          <div class="imgp">
                            <img src="{{ userCard.headIcon }}" [ngClass]="userCard.headIconClass" alt="" />
                          </div>
                          <h4 class="card-title card-block">{{ userCard.title }}</h4>
                          <p class="card-text">{{ userCard.body }}</p>
                          <a href="{{ userCard.url }}" class="btn btn-primary">{{ userCard.buttonText }}</a>
                        </div>
                      </div>
                    </div>
                    <div class="fptitle">
                      <app-banner [banner]="banner" [isHomePage]="true" [isDefaultPageBanner]="false"></app-banner>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="item video" data-time="30000">
    <video id="video" autoplay="true" muted="true" preload="none" src="{{ banner && banner.video }}" poster="{{ banner && banner.additionalImage1 }}"></video>
    <div id="fpslides" class="caption">
      <div id="mmbanner">
        <div class="pattern">
          <div class="homebanner" id="bannerAlert">
            <div class="row">
              <div class="col-sm-12 bannerTopline">
                <app-home-page-announcements-section [noteSections]="noteSections"></app-home-page-announcements-section>
              </div>
            </div>
          </div>
          <div class="container center-container">
            <div class="row">
              <div class="col-sm-12" id="myndc">
                <div class="row mt-80">
                  <div *ngFor="let userCard of userCards; let i = index">
                    <div class="panel panel-default center-text">
                      <div class="panel-body">
                        <div class="imgp">
                          <img src="{{ userCard.headIcon }}" [ngClass]="userCard.headIconClass" alt="" />
                        </div>
                        <h4 class="card-title card-block">{{ userCard.title }}</h4>
                        <p class="card-text">{{ userCard.body }}</p>
                        <a href="{{ userCard.url }}" class="btn btn-primary">{{ userCard.buttonText }}</a>
                      </div>
                    </div>
                  </div>
                  <div class="fptitle">
                    <app-banner [banner]="banner" [isHomePage]="true" [isDefaultPageBanner]="false"></app-banner>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
